<template>
  <b-modal
    :id="modalId"
    :title="$t('breadcrumb.detailsEmployee')"
    size="lg"
    hide-footer
    @show="fetchEmployeeDetails"
  >
    <!-- <div
      v-if="isLoading"
      class="loading-overlay"
    >
      <b-spinner
        variant="primary"
        label="Loading..."
      />
    </div>
    <div v-else> -->
    <!-- Basic Information -->
    <h4 class="section-title">
      {{ $t('service.basic_info') }}
    </h4>
    <div class="detail-cards">
      <b-card
        class="detail-card mb-2 p-2"
        no-body
      >
        <b-row>
          <b-col
            md="4"
            class="mb-2"
          >
            <div class="detail-group">
              <label>{{ $t('field.firstName') }}</label>
              <p class="mb-0">
                {{ data.firstName || $t('general.not_available') }}
              </p>
            </div>
          </b-col>
          <b-col
            md="4"
            class="mb-2"
          >
            <div class="detail-group">
              <label>{{ $t('field.lastName') }}</label>
              <p class="mb-0">
                {{ data.lastName || $t('general.not_available') }}
              </p>
            </div>
          </b-col>
          <b-col
            v-if="!isTelegramUser"
            md="4"
            class="mb-2"
          >
            <div class="detail-group">
              <label>{{ $t('field.email') }}</label>
              <p class="mb-0">
                {{ data.email || $t('general.not_available') }}
              </p>
            </div>
          </b-col>
          <b-col
            md="4"
            class="mb-2"
          >
            <div class="detail-group">
              <label>{{ $t('field.phone') }}</label>
              <p class="mb-0">
                {{ data.phone || $t('general.not_available') }}
              </p>
            </div>
          </b-col>
          <b-col
            v-if="!isTelegramUser"
            md="4"
            class="mb-2"
          >
            <div class="detail-group">
              <label>{{ $t('general.chat_cap') }}</label>
              <p class="mb-0">
                {{ data.serviceCap || $t('general.not_available') }}
              </p>
            </div>
          </b-col>
          <b-col
            v-if="!isTelegramUser"
            md="4"
            class="mb-2"
          >
            <div class="detail-group">
              <label>{{ $t('field.serviceCap') }}</label>
              <p class="mb-0">
                {{ data.totalServiceCap || $t('general.not_available') }}
              </p>
            </div>
          </b-col>
          <b-col
            md="4"
            class="mb-2"
          >
            <div class="detail-group">
              <label>{{ $t('field.role') }}</label>
              <p class="mb-0">
                {{ getRoleName(data.role) }}
              </p>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <!-- Projects Section -->
    <template v-if="!$route.query.isBot">
      <h4 class="section-title mt-4">
        {{ $t('breadcrumb.project') }}
      </h4>
      <div class="detail-group mb-3">
        <div
          v-if="data.projects && data.projects.length"
          class="d-flex flex-wrap"
        >
          <b-badge
            v-for="project in data.projects"
            :key="project.id"
            variant="primary"
            class="mb-1 badge-item"
            style="margin-right: 0.5rem;"
          >
            {{ project.id === 'ALL_PROJECT' ? $t('chat.all') : getProjectName(project) }}
          </b-badge>
        </div>
        <p
          v-else
          class="no-data-text"
        >
          {{ $t('general.noData') }}
        </p>
      </div>

      <!-- Department and Team Section -->
      <h4 class="section-title mt-4">
        {{ $t('general.department_and_team') }}
      </h4>
      <div class="detail-cards">
        <div v-if="data.departmentAndTeam && data.departmentAndTeam.length">
          <b-card
            v-for="(param, index) in data.departmentAndTeam"
            :key="index"
            class="detail-card mb-2"
            no-body
          >
            <b-card-body>
              <div class="detail-group mb-2">
                <label>{{ $t('breadcrumb.department') }}</label>
                <p class="mb-0">
                  {{ getDepartmentName(param.departmentName) }}
                </p>
              </div>
              <div class="detail-group">
                <label>{{ $t('breadcrumb.team') }}</label>
                <div
                  v-if="param.teams && param.teams.length"
                  class="d-flex flex-wrap"
                >
                  <b-badge
                    v-for="team in param.teams"
                    :key="team.id"
                    variant="info"
                    class="mb-1 badge-item"
                    style="margin-right: 0.5rem;"
                  >
                    {{ getTeamName(team) || $t('general.not_available') }}
                  </b-badge>
                </div>
                <p
                  v-else
                  class="no-data-text mb-0"
                >
                  {{ $t('general.noData') }}
                </p>
              </div>
            </b-card-body>
          </b-card>
        </div>
        <p
          v-else
          class="no-data-text"
        >
          {{ $t('general.noData') }}
        </p>
      </div>

      <!-- Service Categories and Types Section -->
      <h4 class="section-title mt-4">
        {{ $t('general.service_category_and_type') }}
      </h4>
      <div class="detail-cards">
        <div v-if="data.serviceCateAndType && data.serviceCateAndType.length">
          <b-card
            class="detail-card mb-2"
            no-body
          >
            <b-card-body>
              <div class="detail-group mb-2">
                <label>{{ $t('breadcrumb.serviceCategory') }}</label>
                <div class="d-flex flex-wrap">
                  <template v-if="data.serviceCateAndType.length">
                    <b-badge
                      v-for="category in data.serviceCateAndType"
                      :key="category.serviceCategory.code"
                      variant="primary"
                      class="mb-1 badge-item"
                      style="margin-right: 0.5rem;"
                    >
                      {{ category.serviceCategory.code === 'ALL_CATEGORY'
                        ? $t('chat.all')
                        : getNameByLang(category.serviceCategory) || $t('general.not_available') }}
                    </b-badge>
                  </template>
                  <p
                    v-else
                    class="no-data-text"
                  >
                    {{ $t('general.noData') }}
                  </p>
                </div>
              </div>
              <div class="detail-group">
                <label>{{ $t('breadcrumb.serviceType') }}</label>
                <div class="d-flex flex-wrap">
                  <template v-if="getAllServiceTypes.length">
                    <b-badge
                      v-for="type in getAllServiceTypes"
                      :key="type.code"
                      variant="primary"
                      class="mb-1 badge-item"
                      style="margin-right: 0.5rem;"
                    >
                      {{ type.code === 'ALL_TYPE'
                        ? $t('chat.all')
                        : getNameByLang(type) || $t('general.not_available') }}
                    </b-badge>
                  </template>
                  <p
                    v-else
                    class="no-data-text"
                  >
                    {{ $t('general.noData') }}
                  </p>
                </div>
              </div>
              <div class="detail-group">
                <label>{{ $t('breadcrumb.serviceSubType') }}</label>
                <div class="d-flex flex-wrap">
                  <template v-if="getAllServiceSubTypes.length">
                    <b-badge
                      v-for="subType in getAllServiceSubTypes"
                      :key="subType.code"
                      variant="primary"
                      class="mb-1 badge-item"
                      style="margin-right: 0.5rem;"
                    >
                      {{ subType.code === 'ALL_SUBTYPE'
                        ? $t('chat.all')
                        : getNameByLang(subType) || $t('general.not_available') }}
                    </b-badge>
                  </template>
                  <p
                    v-else
                    class="no-data-text"
                  >
                    {{ $t('general.noData') }}
                  </p>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
        <p
          v-else
          class="no-data-text"
        >
          {{ $t('general.noData') }}
        </p>
      </div>
    </template>

    <!-- Action Buttons -->
    <div class="text-right mt-4">
      <b-button
        variant="outline-secondary"
        class="px-3"
        @click="closeModal"
      >
        {{ $t('button.close') }}
      </b-button>
    </div>
    <!-- </div> -->
  </b-modal>
</template>

<script>
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BButton,
  BBadge,
  BCardBody,
  // BSpinner,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'

const OperatorRepository = Repository.get('operator')

export default {
  components: {
    BModal,
    BCard,
    BRow,
    BCol,
    BButton,
    BBadge,
    BCardBody,
    // BSpinner,
  },
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      data: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        roleId: null,
        isEnable: 1,
        serviceCap: '5',
        totalServiceCap: '5',
        projects: [],
        departmentAndTeam: [],
        serviceCateAndType: [],
      },
      employeeId: null,
      isLoading: false,
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale.split('-')[0]
    },
    isTelegramUser() {
      return !this.data.email
    },
    getAllServiceSubTypes() {
      // sub type is under service type
      const allTypes = this.data.serviceCateAndType.reduce((types, category) => {
        if (category.serviceTypes && category.serviceTypes.length) {
          types.push(...category.serviceTypes)
        }
        return types
      }, [])

      const uniqueSubTypes = new Map()
      allTypes.forEach(type => {
        if (type.serviceSubTypes && type.serviceSubTypes.length) {
          type.serviceSubTypes.forEach(subType => {
            if (!uniqueSubTypes.has(subType.code)) {
              uniqueSubTypes.set(subType.code, subType)
            }
          })
        }
      })

      return Array.from(uniqueSubTypes.values())
    },
    getAllServiceTypes() {
      const allTypes = this.data.serviceCateAndType.reduce((types, category) => {
        if (category.serviceTypes && category.serviceTypes.length) {
          types.push(...category.serviceTypes)
        }
        return types
      }, [])

      const uniqueTypes = new Map()
      allTypes.forEach(type => {
        if (!uniqueTypes.has(type.code)) {
          uniqueTypes.set(type.code, type)
        }
      })

      return Array.from(uniqueTypes.values())
    },
  },
  methods: {
    getProjectName(project) {
      const locale = this.$i18n.locale.split('-')[0]
      const name = project?.name
      if (!name) return this.$t('general.not_available')
      if (typeof name === 'string') return name
      return name?.[locale] || name?.en || name?.zh || name?.km || name?.vi || this.$t('general.not_available')
    },
    show(id) {
      this.employeeId = id
      this.$bvModal.show(this.modalId)
    },
    fetchEmployeeDetails() {
      this.isLoading = true
      OperatorRepository.show(this.employeeId)
        .then(response => {
          const data = response?.data?.data
          this.data = {
            ...data,
            serviceCap: data.serviceCap?.toString() || '5',
            totalServiceCap: data.totalServiceCap?.toString() || '5',
            projects: data.projects?.map(project => ({
              id: project.projectId,
              name: project.name,
            })) || [],
            departmentAndTeam: data.departmentAndTeamInfo?.map(item => ({
              departmentId: item.departmentId,
              departmentName: item.departmentName,
              teams: item.team || [],
            })) || [],
            serviceCateAndType: data.serviceCateAndType?.map(item => ({
              name: item.name,
              serviceCategory: {
                code: item.serviceCategoryCode,
                name: item.name,
              },
              serviceTypes: item.serviceTypes || [],
            })) || [],
          }
        })
        .catch(error => {
          console.error('Error fetching employee details:', error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
    },
    getRoleName(role) {
      const roleName = role?.name
      if (!roleName) return this.$t('general.not_available')

      if (typeof roleName === 'string') {
        return roleName
      }

      return roleName?.[this.locale] || roleName?.en || roleName?.zh || roleName?.vi || roleName?.km || this.$t('general.not_available')
    },
    getDepartmentName(departmentName) {
      if (!departmentName) return this.$t('general.not_available')

      if (typeof departmentName === 'string') {
        return departmentName
      }

      return departmentName?.[this.locale] || departmentName?.en || this.$t('general.not_available')
    },
    getNameByLang(data) {
      if (!data?.name) return ''
      return data.name?.[this.locale] || data.name?.zh || data.name?.en || data.name?.km || data.name?.vi || this.$t('general.not_available')
    },
    getTeamName(team) {
      if (!team?.teamName) return ''
      return team.teamName?.[this.locale] || team.teamName?.zh || team.teamName?.en || team.teamName?.km || team.teamName?.vi || this.$t('general.not_available')
    },
  },
}
</script>

<style lang="scss" scoped>
.detail-group {
  label {
    font-weight: 600;
    color: #6e6b7b;
    font-size: 0.857rem;
    margin-bottom: 0.5rem;
    text-transform: capitalize;
  }
  p {
    color: #5e5873;
    font-size: 1rem;
  }
}

.detail-cards {
  .detail-card {
    border: 1px solid rgba(47, 47, 47, 0.1);
    border-radius: 0.428rem;
    transition: all 0.3s ease;
    margin-bottom: 1rem;

    &:hover {
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    }

    .card-body {
      padding: 1.5rem;
    }
  }
}

.section-title {
  color: #5e5873;
  font-size: 1.286rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  position: relative;
  padding-bottom: 0.5rem;

}

.badge-item {
  padding: 0.5rem 0.9rem;
  font-size: 0.857rem;
  font-weight: 500;
  border-radius: 0.358rem;
}

.no-data-text {
  color: #b9b9c3;
  font-style: italic;
  margin: 0;
  font-size: 0.857rem;
}

.compact-container {
  width: 100%;
  border: 1px solid rgba(47, 47, 47, 0.1);
  padding: 1rem;
  margin: 1rem;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .compact-card {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 1rem;
    border: 1px solid rgba(47, 47, 47, 0.1);
    border-radius: 5px;
    background-color: #fff;

    .key, .value {
      flex: 1;
    }
  }
}
</style>
